export default (phoneNumber: string) => {
  let parsedPhoneNumber = phoneNumber.replaceAll(' ', '');

  if (parsedPhoneNumber.startsWith('0')) {
    parsedPhoneNumber = parsedPhoneNumber.replace('0', '+31');
  }

  return parsedPhoneNumber;
};
